import { shallowMount } from "@vue/test-utils";
import Identidad from "@/views/Identidad";

describe("Identidad component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Identidad);
  });

  it("Renders del component Identidad", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
